
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"129","height":"69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-584.575 -287.002)"}},[_c('rect',{attrs:{"width":"87.288","height":"8.38","rx":"1.397","transform":"translate(620.794 296.646)","fill":"#f9487f"}}),_c('rect',{attrs:{"width":"94.271","height":"8.38","rx":"1.397","transform":"translate(590.069 319.69)","fill":"#dadfe6","opacity":".61"}}),_c('rect',{attrs:{"width":"20.949","height":"8.38","rx":"1.397","transform":"translate(687.133 319.69)","fill":"#dadfe6","opacity":".61"}}),_c('rect',{attrs:{"width":"20.949","height":"8.38","rx":"1.397","transform":"translate(590.069 347.622)","fill":"#dadfe6","opacity":".61"}}),_c('rect',{attrs:{"width":"107.539","height":"8.38","rx":"1.397","transform":"translate(590.069 333.656)","fill":"#dadfe6","opacity":".61"}}),_c('g',{attrs:{"fill":"#f9487f"}},[_c('path',{attrs:{"d":"M602.846 289.335l-2.277 2.277a1.147 1.147 0 101.622 1.622l2.277-2.277a6.223 6.223 0 118.8 8.8l-2.277 2.277a1.149 1.149 0 101.626 1.624l2.277-2.277a8.519 8.519 0 00-12.044-12.044zM594.045 301.379l2.278-2.274a1.147 1.147 0 00-1.618-1.621l-2.282 2.273a8.52 8.52 0 0012.048 12.048l2.277-2.277a1.177 1.177 0 00.349-.811 1.158 1.158 0 00-1.969-.811l-2.277 2.277a6.223 6.223 0 01-8.8-8.8z"}}),_c('path',{attrs:{"d":"M607.748 297.634a1.159 1.159 0 00-1.969-.811l-5.866 5.866a1.147 1.147 0 101.622 1.622l5.866-5.866a1.111 1.111 0 00.347-.811z"}})])])])
          )
        }
      }
    